import React from "react";
import { Link } from "react-router-dom";
import Stand_art_pic from "../assets/Stand_art_pic.jpg";
import "../styles/Home.css";

function Home() {
  return (
    <div className="home" style={{
      backgroundImage: `url(${Stand_art_pic})`,
    }}>
      <div className="headerContainer">
        <h1 className="head_text"> Hi,I am Pushpit Gill </h1>
        <p>I am a Self taught-artist and an Engineer from Uttar Pradesh . I have been sketching since 2015.</p>
        <p>Currently I am working as a Software engineer and a freelance Artist.You can go through my artwork <Link to="/menu" style={{textDecoration:"none"}}> Gallery </Link>.</p>
        <p>You can Contact me to Order your beautiful Portrait</p>
        <Link to="/services">
          <button> ORDER NOW </button>
        </Link>
      </div>
    </div>
  );
}

export default Home;
